import { useState, useEffect } from "react";
import { assignTask } from "../Services/masterService";
import Modal from "../AlertModal/Modal"

const AssignModal = ({ allEmployees, selectedTask, onClose, onAssignSuccess }) => {
  const [formData, setFormData] = useState({
    taskId: selectedTask.id,
    assignedTo: selectedTask?.assignedTo,
    priority: selectedTask?.priority,
    description: selectedTask?.description,
  });

  const selectedClient = {
    primaryLogistic: selectedTask?.pickupClient?.primaryLogistic,
    secondaryLogistic: selectedTask?.pickupClient?.secondaryLogistic,
  };


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({});

  const showSuccess = (msg) => {
    setModalConfig({
      title: "Success!",
      message: msg,
      type: "success",
    });
    setIsModalOpen(true);
  };

  const showError = (titleMsg, message) => {
    setModalConfig({
      title: titleMsg,
      message: message,
      type: "error",
    });
    setIsModalOpen(true);
  };

  // const sortedEmployees = [...allEmployees].sort((a, b) => {
  //   const priority = (emp) => {
  //     console.log(`Checking employee: ${emp.id}`);
  //     if (emp.id === selectedClient.primaryLogistic) {
  //       console.log(emp.employeeName, "is Primary");
  //       return 1;
  //     }
  //     if (emp.id === selectedClient.secondaryLogistic) {
  //       console.log(emp.employeeName, "is Secondary");
  //       return 2;
  //     }
  //     return 3;
  //   };
  //   return priority(a) - priority(b);
  // });



  // Handle input/select changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (formData.assignedTo == null) {
      showError("Sorry!", "Please select an employee to assign!");
      return;
    }

    try {
      const response = await assignTask(formData);
      if (response.sattus == 1) {
        showSuccess(`Task assigned successfully!`);
        onAssignSuccess(); // Refresh tasks or update UI
        onClose(); // Close modal
        setFormData({ assignedTo: "", priority: "NORMAL", description: "" }); // Reset form
      } else {
        showError("Sorry!", "Something went wrong!");
      }
    } catch (error) {
      console.error("Error assigning task:", error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-green-800">Assign Task</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-4">
          <form className="space-y-4">
            {/* Employee Select */}
            {/* <div>
              <label htmlFor="assignedTo" className="block text-sm font-medium text-gray-700 mb-1">
                Assign to
              </label>
              <select
                id="assignedTo"
                value={formData.assignedTo}
                onChange={handleChange}
                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
              >
                <option value="">-Select Employee-</option>
                {allEmployees.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.employeeName}
                  </option>
                ))}
              </select>
            </div> */}
            <div>
              <label
                htmlFor="assignedTo"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Assign to
              </label>

              {(() => {
                // ✅ Sort employees so primary & secondary logistics come first
                const sortedEmployees = [...allEmployees].sort((a, b) => {
                  const priority = (emp) => {
                    if (emp.id === selectedClient.primaryLogistic) return 1;
                    if (emp.id === selectedClient.secondaryLogistic) return 2;
                    return 3;
                  };
                  return priority(a) - priority(b);
                });

                return (
                  <select
                    id="assignedTo"
                    value={formData.assignedTo}
                    onChange={handleChange}
                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                  >
                    <option value="">-Select Employee-</option>
                    {sortedEmployees.map((item) => {
                      const isPrimary = item.id === selectedClient.primaryLogistic;
                      const isSecondary = item.id === selectedClient.secondaryLogistic;

                      return (
                        <option
                          key={item.id}
                          value={item.id}
                          style={{
                            fontWeight: isPrimary || isSecondary ? "bold" : "normal",
                            color: isPrimary
                              ? "green"
                              : isSecondary
                                ? "#0ea5e9" // sky blue for secondary
                                : "black",
                          }}
                        >
                          {item.employeeName}
                          {isPrimary
                            ? " (Primary Logistic)"
                            : isSecondary
                              ? " (Secondary Logistic)"
                              : ""}
                        </option>
                      );
                    })}
                  </select>
                );
              })()}
            </div>


            {/* Priority */}
            <div>
              <label htmlFor="priority" className="block text-sm font-medium text-gray-700 mb-1">
                Priority
              </label>
              <select
                id="priority"
                value={formData.priority}
                onChange={handleChange}
                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
              >
                <option value="NORMAL">NORMAL</option>
                <option value="HIGH">HIGH</option>
              </select>
            </div>

            {/* Description */}
            <div>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <textarea
                id="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Write a description"
                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                rows={3}
              ></textarea>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="flex justify-end px-6 py-4 border-t border-gray-200 space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors"
          >
            Assign
          </button>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
      />
    </div>
  );
};

export default AssignModal;
